import {useBrandStore} from './brandStore';
import {useI18nStore} from '../i18n/i18nStore';
export function BrandAppDownload(){
  const apk=useBrandStore(s=>s.apk);const language=useI18nStore(s=>s.language);
  if(!apk.url||!/Android/i.test(navigator.userAgent))return null;
  return <a className="brand-apk-download" href={apk.url} rel="noopener noreferrer">{language==='pt-BR'?'Baixar app Android':language==='es'?'Descargar app Android':'Download Android app'} {apk.versionName?'· v'+apk.versionName:''}</a>;
}
